import { queryOptions } from '@tanstack/react-query';
import { userInfoQueryFunction } from '@/common/queries/userInfo/userInfoQueryFunction.ts';

export const userInfoQueryOptions = (enable = true) =>
  queryOptions({
    queryKey: ['user-info'],
    queryFn: userInfoQueryFunction,
    enabled: enable,
    gcTime: 1000 * 60 * 60 * 3,
    staleTime: 1000 * 60 * 60 * 3,
  });
